"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchClient = void 0;

var base_js_1 = require("./base.js");

var FetchResponse = /*#__PURE__*/function (_base_js_1$BaseRespon) {
  (0, _inherits2.default)(FetchResponse, _base_js_1$BaseRespon);

  var _super = _createSuper(FetchResponse);

  /**
   * BaseResponse facade for fetch API Response
   * @param {Response} response
   */
  function FetchResponse(response) {
    var _this;

    (0, _classCallCheck2.default)(this, FetchResponse);
    _this = _super.call(this);
    _this.response = response;
    return _this;
  }

  (0, _createClass2.default)(FetchResponse, [{
    key: "status",
    get: function get() {
      return this.response.status;
    }
  }, {
    key: "getHeader",
    value: function getHeader(name) {
      return this.response.headers.get(name);
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.response.arrayBuffer) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.response.arrayBuffer();

              case 3:
                _context.t0 = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.next = 8;
                return this.response.buffer();

              case 8:
                _context.t0 = _context.sent.buffer;

              case 9:
                data = _context.t0;
                return _context.abrupt("return", data);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }]);
  return FetchResponse;
}(base_js_1.BaseResponse);

var FetchClient = /*#__PURE__*/function (_base_js_1$BaseClient) {
  (0, _inherits2.default)(FetchClient, _base_js_1$BaseClient);

  var _super2 = _createSuper(FetchClient);

  function FetchClient(url, credentials) {
    var _this2;

    (0, _classCallCheck2.default)(this, FetchClient);
    _this2 = _super2.call(this, url);
    _this2.credentials = credentials;
    return _this2;
  }

  (0, _createClass2.default)(FetchClient, [{
    key: "request",
    value: function () {
      var _request = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _ref,
            headers,
            credentials,
            signal,
            response,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, headers = _ref.headers, credentials = _ref.credentials, signal = _ref.signal;
                _context2.next = 3;
                return fetch(this.url, {
                  headers: headers,
                  credentials: credentials,
                  signal: signal
                });

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", new FetchResponse(response));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request() {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }]);
  return FetchClient;
}(base_js_1.BaseClient);

exports.FetchClient = FetchClient;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0lBRU1BLGE7Ozs7O0VBQ0o7Ozs7RUFJQSx1QkFBWUMsUUFBWixFQUFvQjtJQUFBOztJQUFBO0lBQ2xCO0lBQ0EsTUFBS0EsUUFBTCxHQUFnQkEsUUFBaEI7SUFGa0I7RUFHbkI7Ozs7U0FFRCxlQUFVO01BQ1IsT0FBTyxLQUFLQSxRQUFMLENBQWNDLE1BQXJCO0lBQ0Q7OztXQUVELG1CQUFVQyxJQUFWLEVBQWM7TUFDWixPQUFPLEtBQUtGLFFBQUwsQ0FBY0csT0FBZCxDQUFzQkMsR0FBdEIsQ0FBMEJGLElBQTFCLENBQVA7SUFDRDs7Ozs2RkFFRDtRQUFBO1FBQUE7VUFBQTtZQUFBO2NBQUE7Z0JBQUEsS0FDZSxLQUFLRixRQUFMLENBQWNLLFdBRDdCO2tCQUFBO2tCQUFBO2dCQUFBOztnQkFBQTtnQkFBQSxPQUVZLEtBQUtMLFFBQUwsQ0FBY0ssV0FBZCxFQUZaOztjQUFBO2dCQUFBO2dCQUFBO2dCQUFBOztjQUFBO2dCQUFBO2dCQUFBLE9BR2EsS0FBS0wsUUFBTCxDQUFjTSxNQUFkLEVBSGI7O2NBQUE7Z0JBQUEsNEJBR3FDQSxNQUhyQzs7Y0FBQTtnQkFDUUMsSUFEUjtnQkFBQSxpQ0FJU0EsSUFKVDs7Y0FBQTtjQUFBO2dCQUFBO1lBQUE7VUFBQTtRQUFBO01BQUEsQzs7Ozs7Ozs7OztFQWxCMEJDLHNCOztJQTBCZkMsVzs7Ozs7RUFDWCxxQkFBWUMsR0FBWixFQUFpQkMsV0FBakIsRUFBNEI7SUFBQTs7SUFBQTtJQUMxQiw0QkFBTUQsR0FBTjtJQUNBLE9BQUtDLFdBQUwsR0FBbUJBLFdBQW5CO0lBRjBCO0VBRzNCOzs7Ozs2RkFFRDtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTs7UUFBQTtVQUFBO1lBQUE7Y0FBQTtnQkFBQSxrRUFBaUQsRUFBakQsRUFBZ0JSLE9BQWhCLFFBQWdCQSxPQUFoQixFQUF5QlEsV0FBekIsUUFBeUJBLFdBQXpCLEVBQXNDQyxNQUF0QyxRQUFzQ0EsTUFBdEM7Z0JBQUE7Z0JBQUEsT0FDeUJDLEtBQUssQ0FBQyxLQUFLSCxHQUFOLEVBQVc7a0JBQ3JDUCxPQUFPLEVBQVBBLE9BRHFDO2tCQUM1QlEsV0FBVyxFQUFYQSxXQUQ0QjtrQkFDZkMsTUFBTSxFQUFOQTtnQkFEZSxDQUFYLENBRDlCOztjQUFBO2dCQUNRWixRQURSO2dCQUFBLGtDQUlTLElBQUlELGFBQUosQ0FBa0JDLFFBQWxCLENBSlQ7O2NBQUE7Y0FBQTtnQkFBQTtZQUFBO1VBQUE7UUFBQTtNQUFBLEM7Ozs7Ozs7Ozs7RUFOK0JRLG9COztBQUFqQ00iLCJuYW1lcyI6WyJGZXRjaFJlc3BvbnNlIiwicmVzcG9uc2UiLCJzdGF0dXMiLCJuYW1lIiwiaGVhZGVycyIsImdldCIsImFycmF5QnVmZmVyIiwiYnVmZmVyIiwiZGF0YSIsImJhc2VfanNfMSIsIkZldGNoQ2xpZW50IiwidXJsIiwiY3JlZGVudGlhbHMiLCJzaWduYWwiLCJmZXRjaCIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vZGlzdC1tb2R1bGUvc291cmNlL2NsaWVudC9mZXRjaC5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==